import { CloudDownload } from '@mui/icons-material';
import { Box } from '@mui/material';

type AvailabilityStatusIndicatorProps = {
    isLoaded: boolean;
    isActive: boolean;
};

export default function AvailabilityStatusIndicator({
    isLoaded,
    isActive,
}: AvailabilityStatusIndicatorProps) {
    if (!isLoaded) {
        return (
            <CloudDownload
                fontSize="small"
                sx={{ color: 'grey.500', fontSize: 14, mt: 0.5 }}
            />
        );
    }

    return (
        <Box
            sx={{
                mt: 0.75,
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: isActive ? 'success.main' : 'grey.500',
            }}
        />
    );
}
